import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, Inscription, UploadDocumentIcon } from '@common-fe/common-fe';

import waves from '@/assets/backgrounds/wavesBackground.svg';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

interface Props extends BoxExtendedProps {
  title: string;
}

const UploadFileByLinkHeader: React.FC<Props> = ({ title, ...props }) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="UploadFilesHeader_wrapper"
      height="40svh"
      width="100svw"
      background={{ color: 'background1' }}
      round={{ corner: 'bottom', size: 'container2Round' }}
      pad={{ vertical: 'spacing16', horizontal: 'spacing8' }}
      {...props}
    >
      <Box
        height="calc(40svh)"
        style={{
          rotate: '180deg',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
        }}
        background={{ image: `url(${waves})`, size: '150%' }}
        justify="center"
        overflow="hidden"
      />
      <Box
        align="center"
        justify="center"
        height="100%"
        style={{ zIndex: 2 }}
      >
        <Inscription
          size="16px"
          weight={700}
          lineHeight="22px"
          color="textOnColor"
        >
          {title}
        </Inscription>

        <Box
          data-testid="UploadFileByQrLinkProcess_receipt_icon"
          margin={{ vertical: 'spacing24' }}
        >
          <UploadDocumentIcon size="52px" color="canvas" />
        </Box>

        <Inscription
          size="24px"
          weight={700}
          lineHeight="32px"
          color="textOnColor"
        >
          {t('Upload a File')}
        </Inscription>

        <Box margin={{ top: 'spacing12' }}>
          <Inscription
            weight={whiteLabelingConfig.fonts?.reimbursementWeight || 400}
            lineHeight="22px"
            textAlign="center"
            color="textOnColor"
            style={{ opacity: 0.5 }}
          >
            {t('Add file from your phone or use camera to take a photo of new letter of medical necessity')}
          </Inscription>
        </Box>
      </Box>
    </Box>
  );
};

export default UploadFileByLinkHeader;
